import { render, staticRenderFns } from "./TrackerAcordos.vue?vue&type=template&id=734845df"
import script from "./TrackerAcordos.vue?vue&type=script&lang=js"
export * from "./TrackerAcordos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports